import React from "react";
import "./Loader.css";

const Loader = ({ size = "md", label = "Loading..." }) => {
  return (
    <div className="app-loader" role="status" aria-live="polite" aria-label={label}>
      <span className={`app-loader-spinner app-loader-spinner--${size}`} aria-hidden="true" />
      <span className="app-loader-text">{label}</span>
    </div>
  );
};

export default Loader;
